import React, { Component } from 'react'
import { Upload } from 'antd'
import Col from 'react-bootstrap/Col'
import '../../wallet.css'
import './transferir.css'
import { Row } from 'react-bootstrap'
import { Select, Input, Form } from 'antd'
import { connect } from 'react-redux'
import { getBtcOut } from '../../../../redux-flow/actions/wallet_btc'
import { infoRequired } from '../../../../utils/validators'
import { getInfoLocalStorage } from '../../../../utils/api'

const mapStateToProps = state => ({
    userid: state.login.userid,
    cashSubmit: state.wallet_btc.cashSubmit,
    cashSuccess: state.wallet_btc.cashSuccess,
    message: state.wallet_btc.cashMessage
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, value, tabAtiva, priority, userid) => e => {
        e.preventDefault()
        dispatch(getBtcOut(form, value, tabAtiva, priority, userid))
    }
})

const Option = Select.Option

const BtcOutForm = Form.create({ name: 'btc-out' })(
    connect(mapStateToProps, mapDispatchToProps)(
        ({ handleSubmit, value, form, tabAtiva, onClick, priority, userid, cashSubmit, btcBalance, fee, size }) => (
            <Form
                onSubmit={handleSubmit(form, value, tabAtiva, priority, userid)}
            >
                <Row className='mt-2'>
                    <Col md={6} className='d-flex flex-column'>
                        <label className='titulosTransferir mb-2'>Nome</label> 
                        <Form.Item>
                            {form.getFieldDecorator('name', {
                                rules: [ infoRequired ]
                            })(
                                <Input type='text' className='inputTransferir'/>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6} className='d-flex flex-column'>
                        <label className='titulosTransferir mb-2'>Chave da carteira</label> 
                        <Form.Item>
                            {form.getFieldDecorator('address', {
                                    rules: [ infoRequired ]
                                })(
                                <Input type='text' className='inputTransferir'/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Row className='mt-4'>
                    {/* <Col md={6} className='p-0 pl-3'>
                        <label className='titulosTransferir mb-2 pr-3'>Salvar como favorito?</label> 
                        <div className='d-flex'>
                            <Col md={3} className='p-0 mr-1'>
                                <div id='salvar' className={`tabFav ${tabAtiva == 'salvar' ? 'tabFavActive' : ''}`} onClick={() => onClick('salvar')}>
                                    <label className='nomeTabTransf'>Sim</label>
                                </div> 
                            </Col>

                            <Col md={3} className='p-0 ml-1'>
                                <div id='naoSalvar' className={`tabFav ${tabAtiva == 'naoSalvar' ? 'tabFavActive' : ''}`} onClick={() => onClick('naoSalvar')}>
                                    <label className='nomeTabTransf'>Não</label>
                                </div> 
                            </Col>                                  
                        </div>
                    </Col> */}

                    <Col md={12}>
                        { cashSubmit ? 
                            <div className="mt-2">
                                <h4 className="tx-pink">Realizando transferência...</h4>
                            </div> 
                        :   <div className="mt-5">
                                {btcBalance > (parseFloat(value) + (parseFloat(fee))) ?
                                    <button className="btnSubmit" disabled={value <= 0 ? true : false}>Enviar</button>
                                :
                                    <label style={{color: "red"}}>Saldo insuficiente</label>
                                }
                        </div>
                        }
                    </Col>
                </Row> 
            </Form>
        )
    )
)

class NovoFavorecido extends Component {
    constructor(props) {
    super(props)
    this.state = {
        tabAtiva: 'salvar',
        btcBalance: getInfoLocalStorage().btcBalance  
                    // fillBackground: false,
    }}

    onClickTab = (id) => {
        if(this.state.tabAtiva != id){
            this.setState({tabAtiva:id})
        }
    }

        render() {
            return (
                <>            
                      <BtcOutForm size={this.props.size} fee={this.props.fee} btcBalance={this.state.btcBalance} priority={this.props.priority} value={this.props.value} tabAtiva={this.state.tabAtiva} onClick={this.onClickTab} />
                </>
            )
        }
    }

export default NovoFavorecido